"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditRiskAssessmentReportFrequencyRef = void 0;
const Field_type_1 = require("../../types/Field.type");
exports.CreditRiskAssessmentReportFrequencyRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.credit_risk_assessment_report_frequency.label',
    fallbackLabel: 'Do you report the results of your merchant risk assessment to any regulatory authorities, and how often do you need to report or undergo scrutiny by the mentioned authorities?',
    type: Field_type_1.FieldType.Enum,
    options: [
        { key: 'MORE_ONCE_A_YEAR', label: 'fields.enm.credit_risk_assessment_report_frequency.options.MORE_ONCE_A_YEAR', fallbackLabel: 'More than once a year' },
        { key: 'ANNUALLY', label: 'fields.enm.credit_risk_assessment_report_frequency.options.ANNUALLY', fallbackLabel: 'Annually' },
        { key: 'MORE_THAN_ANNUALLY', label: 'fields.enm.credit_risk_assessment_report_frequency.options.MORE_THAN_ANNUALLY', fallbackLabel: 'More than annually or incident-triggered' },
        { key: 'NO_REPORTS', label: 'fields.enm.credit_risk_assessment_report_frequency.options.NO_REPORTS', fallbackLabel: 'We do not report to any regulatory authorities' },
    ],
    trackFieldValueWithAnalytics: false,
};
